// reset password api
export const GET_AVAILABLE_ENTITY_DATA_FIELD =
  '/api/member-manager/get-available-entity-data-field';
